import React, { LazyExoticComponent } from 'react';

import { UserRoleDto } from '@/api/generated';

import { RouteStateModel } from './RouteState.model.ts';

export enum RouteEnum {
  ANALYSIS_REMARKS = '/analysis-remarks',
  CANDIDATE_DETAILS = '/processes/:processId/candidates/:candidateId',
  EXPERIENCE_COMPANIES = '/experience-companies',
  FORBIDDEN = '/forbidden',
  INTERVIEW_SIMULATION = '/processes/:processId/candidates/:candidateId/interview-simulation/:interviewSimulationId',
  LOGIN_ELIVION = '/login/elivion',
  LOGIN_SUCCESSFUL = '/login-successful',
  MEETING_DETAILS = '/meetings/:meetingId',
  MEETINGS = '/meetings',
  NOT_AUTHORIZED = '/not-authorized',
  NOT_FOUND = '/not-found',
  PROCESS_DETAILS = '/processes/:processId',
  PROCESS_TEMPLATES = '/process-templates',
  PROCESSES = '/processes',
  ROOT = '/',
  STATISTICS = '/statistics',
}

export interface RouteModel {
  addons?:
    | LazyExoticComponent<React.FC<{ route: RouteStateModel }>>
    | React.FC<{ route: RouteStateModel }>;
  component:
    | LazyExoticComponent<React.FC<{ route: RouteStateModel }>>
    | React.FC<{ route: RouteStateModel }>;
  path: RouteEnum;
  roles?: UserRoleDto[];
}
